import { useLocation } from 'react-router-dom';

export default function useIsRoot(): boolean {
  const { pathname } = useLocation();
  return pathname === '/root' || pathname.startsWith('/root/');
}
